*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  /**
   * @prop --ch-radio-group__radio-container-size:
   * Specifies the size for the container of the `radio__input` and `radio__option` elements.
   * @default min(1em, 20px)
   */
  --ch-radio-group__radio-container-size: min(1em, 20px);
  /**
   * @prop --ch-radio-group__radio-option-size:
   * Specifies the size for the `radio__option` element.
   * @default 50%
   */
  --ch-radio-group__radio-option-size: 50%;
  pointer-events: none;
}

:host(.ch-radio-group--direction-horizontal) {
  display: flex;
  flex-wrap: wrap;
}

:host(.ch-radio-group--direction-vertical) {
  display: inline-grid;
  grid-auto-rows: max-content;
}

.radio-item {
  display: flex;
  align-items: center;
  align-self: stretch;
  touch-action: manipulation;
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  inline-size: var(--ch-radio-group__radio-container-size);
  block-size: var(--ch-radio-group__radio-container-size);
  border: 1px solid currentColor;
  border-radius: 50%;
}
.container--checked {
  background-color: transparent;
}

.input {
  display: flex;
  inline-size: 100%;
  block-size: 100%;
  opacity: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
}
.input--enabled {
  pointer-events: all;
}

.option {
  position: absolute;
  inline-size: var(--ch-radio-group__radio-option-size);
  block-size: var(--ch-radio-group__radio-option-size);
  background-color: currentColor;
  border-radius: 50%;
  pointer-events: none;
}
.option--unchecked {
  opacity: 0;
  visibility: hidden;
}

.label {
  cursor: pointer;
}
.label--enabled {
  pointer-events: all;
}